export default __webpack_public_path__ + "static/media/image6.b344f738.jpeg";